// import React from 'react';
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';
import ScrollToTop from './ScrollToTop';

import Header from './components/header'; 
import Footer from './components/footer'; 
import Home from './pages/home';
import About from './pages/about'; 
import Projects from './pages/products'; 
import ProjectRight from './pages/project-right'; 
import UBend from './pages/u_bend'; 
import CBend from './pages/c_bend'; 
import YBend from './pages/y_bend'; 
import CopperFilter from './pages/copper_filter'; 
import CopperTripod from './pages/copper_tripod';
import CopperTee from './pages/copper_tee'; 
import CopperElbow from './pages/copper_elbow';
import CopperCap from './pages/copper_cap'; 
import CopperStraightPipe from './pages/copper_straight_pipe'; 
import CopperPancake from './pages/copper_pancake'; 
import LevelWoundCoil from './pages/level_wound_coil';
import AlluminumFoilForFins from './pages/alluminum_foil_for_fins'; 
import CopperFoil from './pages/copper_foil'; 
import BrazzingRoad from './pages/brazzing_road'; 
import NRVValves from './pages/nrv_valves';
import Distributors from './pages/distributors'; 
import Contact from './pages/contact'; 
import Blog from './pages/blog'; 
import CopperFoilList from './pages/copper_foil_list'; 
import CopperStraigthPipeList from './pages/copper_straight_pipe_list'; 
import CopperPancakeList from './pages/copper_pancake_list'; 
import CopperFittingList from './pages/copper_fitting_list'; 
import LevelWoundCoilList from './pages/level_wound_coil_list'; 
import BlogSingle from './pages/blog-single'; 

function App() {
  return (
    <Router>
      <Header />
        <ScrollToTop /> 
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/products" element={<Projects />} />
        <Route path="/project-right" element={<ProjectRight />} />
        <Route path="/u_bend" element={<UBend />} />
        <Route path="/c_bend" element={<CBend />} />
        <Route path="/y_bend" element={<YBend />} />
        <Route path="/copper_filter" element={<CopperFilter />} />
        <Route path="/copper_tripod" element={< CopperTripod />} />
        <Route path="/copper_tee" element={< CopperTee />} />
        <Route path="/copper_elbow" element={< CopperElbow />} />
        <Route path="/copper_cap" element={< CopperCap />} />
        <Route path="/copper_straight_pipe" element={< CopperStraightPipe />} />
        <Route path="/copper_pancake" element={< CopperPancake />} />
        <Route path="/level_wound_coil" element={< LevelWoundCoil />} />
        <Route path="/alluminum_foil_for_fins" element={< AlluminumFoilForFins />} />
        <Route path="/copper_foil" element={< CopperFoil />} />
        <Route path="/brazzing_road" element={< BrazzingRoad />} />
        <Route path="/nrv_valves" element={< NRVValves />} />
        <Route path="/distributors" element={< Distributors />} />
        <Route path="/contact" element={< Contact />} />
        <Route path="/blog" element={< Blog />} />
        <Route path="/ScrollToTop" element={< ScrollToTop />} />
        <Route path="/copper_foil_list" element={< CopperFoilList />} />
        <Route path="/copper_straight_pipe_list" element={< CopperStraigthPipeList />} />
        <Route path="/copper_pancake_list" element={< CopperPancakeList />} />
        <Route path="/copper_fitting_list" element={< CopperFittingList />} />
        <Route path="/level_wound_coil_list" element={< LevelWoundCoilList />} />
        <Route path="/blog-single" element={< BlogSingle />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
